import Pagination from '@/components/pagination/index.vue';
import Service from '../org-service';
import DictService from '../../service/service-service';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      cropList: [],
      serviceScore: [],
      serviceArea: [],
      serviceProject: [],
      serviceRegion: [],
      categoryList: [{
        name: '托管服务',
        type: '001'
      }, {
        name: '农机服务',
        type: '003'
      }, {
        name: '飞防服务',
        type: '002'
      }],
      total: 0,
      queryName: {},
      query: {
        skip: 0,
        category: '',
        limit: 10,
        crop: '',
        scoreLevel: '',
        areaLevel: '',
        sortBy: '',
        areaCode: ''
      },
      activeType: '',
      list: [],
      list2: [],
      num: '',
      tId: '66aaf784247b9fffdb5eba0b'
      // tId: '6556cfd1e8debd4239608dc3'
    };
  },

  created() {
    console.log(999, this.$route.query);
    this.activeType = this.$route.query.type || 'all';
    console.log(this.activeType, '111');
    this.resetQuery();
    this.getTypeList();
  },

  watch: {
    $route(newRoute) {
      if (newRoute) {
        this.activeType = newRoute.query.type;
        this.resetQuery();
        this.getTypeList();
      }
    }
  },
  methods: {
    getRegionDisplay(regionList) {
      // console.log(regionList);
      if (!regionList.length) return '';
      const arr = regionList.map(item => {
        // 确保 item.area 存在并替换
        if (item.area && typeof item.area === 'string') {
          return item.area.replace(/广西壮族自治区百色市/g, '');
        }
        return item.area;  // 如果没有匹配，直接返回原始值
      });
      return arr.join('，');
    },

    getList(page) {
      if (page) {
        this.query.skip = (page.pageNo - 1) * 10;
        this.query.limit = 10;
      } else {
        this.query.skip = '0';
      }
      const obj = {};
      Object.keys(this.query).forEach(item => {
        if (this.query[item] && (this.query[item] !== 'all')) {
          obj[item] = this.query[item];
        }
      });
      console.log(obj);
      this.num = obj.category;
      // console.log(this.num);
      this.getTableList(obj);
    },

    getTableList() {
      // Service.getPartnerList({ tId: this.tId }).then(res => {
      //   this.list = res;
      //   console.log(this.list);
      //   this.total = res.total;

      // });
      Service.getPartnerList({ tId: this.tId, skip: this.query.skip, limit: this.query.limit }).then(res => {
        // 初始化两个数组，用来保存符合不同条件的项
        const category002List = [];
        const category003List = [];

        // 遍历返回的每一项
        res.forEach(item => {
          // 确保每项有 category 字段
          if (item.category) {
            const categoryPrefix = item.category.slice(0, 3); // 提取前三位

            if (categoryPrefix === '002') {
              // 如果前三位是 '002'，添加到 category002List
              category002List.push(item);
            } else if (categoryPrefix === '003') {
              // 如果前三位是 '003'，添加到 category003List
              category003List.push(item);
            }
          }
        });

        this.list2 = category002List;
        this.list = category003List;
        console.log(this.list);
      });
    },

    resetQuery() {
      this.query = {
        skip: 0,
        limit: 10,
        crop: '',
        scoreLevel: '',
        areaLevel: '',
        sortBy: '',
        category: '',
        areaCode: ''
      };
      if (this.activeType !== 'all') {
        this.query.category = this.activeType;
      }
      this.queryName = {};
      this.getList();
    },

    delquery(key, value) {
      this.query[value] = '';
      this.queryName[value] = '';
      this.getList();
    },

    getTypeList() {
      if (this.activeType !== 'all') {
        DictService.getServiceCategoryList({ tId: this.tId, code: this.activeType }).then(res => {
          this.serviceProject = res;
        });
      }
      DictService.getServiceScoreLevelList().then(res => {
        this.serviceScore = res;
      });
      DictService.getServiceAreaLevelList().then(res => {
        this.serviceArea = res;
      });
      DictService.getAreaList({ current: '451022', level: 3 }).then(res => {
        const result = res.result.filter(item => item.id && item.id !== '150721402');
        this.serviceRegion = result;
      });
    },

    updateQueryParmas(type, item) {
      console.log(type, item);
      this.query[type] = item.type || item.id || item._id;
      this.queryName[type] = item.name;
      this.getList();
    },

    getTableListBySort(type) {
      if (this.query.sortBy !== type) {
        this.query.sort = 1;
      } else {
        this.query.sort = this.query.sort === 1 ? -1 : 1;
      }
      this.query.sortBy = type;
      this.getList();
    },

    toDetail(id, name) {
      // console.log(id, '11');
      // console.log(this.activeType, '22');
      if (this.activeType === '003') {
        // this.$router.push('/socialized-service/partner/partner-detail1?id=' + id + '&type=' + this.activeType);
        this.$router.push('/socialized-service/partner/partner-list1?id=' + id + '&name=' + name + '&type=' + this.activeType);
      } else {
        this.$router.push('/socialized-service/partner/partner-list1?id=' + id + '&name=' + name + '&type=' + this.activeType);
      }

    },
    toOther(url) {
      // console.log(url);
      this.$router.push(url);
    }
  }
};
